$(document).on("click", ".question_product,.faq_question,.footer_menu p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.footer_menu p').removeClass('active');
    jQuery('.question_product,.faq_question,.footer_menu p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   //jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    //jQuery(this).removeClass('active');
//video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});



$(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).prev().val();
text = text.trim();
text = text.replace(" ", "+");
var new_link ='/search?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).next().trigger('click');
}});


$(document).on("click", ".tabs_main_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tabs_main_item').removeClass('active');
$(this).addClass('active');
$('.columns_center_slider_tab').hide();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"]').show();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"] .slick-slider').slick('refresh');
});




$(document).on("click", ".custom_tabs_item", function (e) {
var data_tab = $(this).attr('data-tab');
$('.custom_tabs_item').removeClass('active');
$(this).addClass('active');
$('.custom_tab_content').hide();
$('.custom_tab_content[data-tab="'+data_tab+'"]').show();
});

/*$(document).on("click", ".bundle-flex-product .bundle-custom-btn button.custom_add_to_cart", function (e) {
var product_image = $(this).parents('.product-grid-item').find('.product__media img').eq(0).attr('src');
var product_image = product_image.split("?")[0];
var product_title = $(this).parents('.product-grid-item').find('.product-grid-item__title').text();
$('.design_item.choose_design').eq(0).find('.design_item_selected img').attr('src',product_image);
$('.design_item.choose_design').eq(0).find('.design_item_selected p').text(product_title);
$('.design_item.choose_design').eq(0).removeClass('choose_design').addClass('selected_design');
});*/


 $(document).ready(function(){
$('.plans_main_item[data_tab="1"]').trigger('click');
})

$(document).on("click", ".design_item.choose_design,.design_item.selected_design", function (e) {
$('.featured-collection:has(.bundle-flex-product)').show();
$('.design_item.selected_design').addClass('choose_design');
$('.design_item').removeClass('selected_design');
var designs_total = parseInt($('.plans_main_item.active').attr('data_tab'));
designs_total = designs_total+1;
  var selected_designs =0;
$('.meal-wrapper .product').each(function(){
var selected_quantity = $(this).find('input.custom-count').val();
selected_designs = selected_designs + selected_quantity;
});
var left_designs = designs_total-selected_designs;
if(left_designs>0){
$('.popup_bottom_buttons_main_left').show();
$('.popup_bottom_buttons_main_add').hide();
$('span.left_designs').text(left_designs);
} else {
$('.popup_bottom_buttons_main_left').hide();
$('.popup_bottom_buttons_main_add').show();
}
});





$(document).on("click", ".featured-collection.show_price_single .custom_close_popup,.featured-collection.show_price_single .custom_close_popup", function (e) {
$('.featured-collection:has(.bundle-flex-product)').hide();
$('.meal-wrapper .product').each(function(){
var product_id = $(this).parents('.product-grid-item').find('input[name="id"]').val();
var product_price = $(this).parents('.product-grid-item').find('a.product-grid-item__price.price span').text();
var product_cprice = $(this).parents('.product-grid-item').find('a.product-grid-item__price.price s').text();
$('.one_time_custom_checkout').attr('variant_id',product_id);
$('.price_single_one_time').text(product_price);
if ($(this).parents('.product-grid-item').find('a.product-grid-item__price.price s').hasClass("null")) {
} else {
$('.price_compare_one_time').text(product_cprice);
}
 if( $('.bundle-flex-product .bundle-custom-btn button.custom_add_to_cart[style="display: none;"]').length )  {
$('.one_time_custom_checkout').removeAttr('disabled');
$('.price_flex_inner_one_time').addClass('active');
} else {
$('.one_time_custom_checkout').attr('disabled','disabled');
$('.price_flex_inner_one_time').removeClass('active');
 }
});
});


$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", '.featured-collection:not(.show_price_single) .bundle-flex-product .product-grid-item', function (e) {
setTimeout(function() {
var designs_total = parseInt($('.plans_main_item.active').attr('data_tab'));
designs_total = designs_total+1;
  var selected_designs =0;
$('.meal-wrapper .product').each(function(){
var selected_quantity = parseInt($(this).find('input.custom-count').val());
selected_designs = selected_designs + selected_quantity;
});
var left_designs = designs_total-selected_designs;
if(left_designs>0){
$('.popup_bottom_buttons_main_left').show();
$('.popup_bottom_buttons_main_add').hide();
$('span.left_designs').text(left_designs).attr('value',left_designs);
} else {
$('.popup_bottom_buttons_main_left').hide();
$('.popup_bottom_buttons_main_add').show();
}

$('.selected_design_item_custom').each(function(){
var this_element_new = $(this);
var product_id = $(this).find('.remove_design').attr('data_id');
var check_element = $('.custom-counter.bundle-count[unique_id="'+product_id+'"]');
 if( check_element.length ){
} else {
  this_element_new.remove();
}
});


}, 500);
});

$(document).on("click", ".featured-collection:not(.show_price_single) .custom_hk_button.add_to_cart_popup.popup_bottom_buttons", function (e) {
$('.checkout-subscription').trigger('click');
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
setTimeout(function() {
this_element.removeClass('loading_hk');
$('.featured-collection:has(.bundle-flex-product)').hide();
}, 3500);
});


$(document).on("click", ".overlay-bundle", function (e) {
$(this).parents('.relative').find('.custom_close_popup').trigger('click');
});
$(document).on("click", ".popup_header svg", function (e) {
$(this).parents('.relative').find('.custom_close_popup').trigger('click');
});


$(document).on("click", '.featured-collection.show_price_single .bundle-flex-product .product-grid-item', function (e) {
setTimeout(function() {
var designs_total = 1;
  var selected_designs =0;
$('.meal-wrapper .product').each(function(){
$(this).find('button.custom-btn').removeAttr('disabled');
var selected_quantity = parseInt($(this).find('input.custom-count').val());
selected_designs = selected_designs + selected_quantity;
});
var left_designs = designs_total-selected_designs;
if(left_designs>0){
$('.popup_bottom_buttons_main_left').show();
$('.popup_bottom_buttons_main_add').hide();
$('span.left_designs').text(left_designs).attr('value',left_designs);
} else {
$('.popup_bottom_buttons_main_left').hide();
$('.popup_bottom_buttons_main_add').show()
}
  $('.bundle-flex-product .bundle-custom-btn button.custom_add_to_cart[style="display: none;"]').each(function (e) {
var product_id = $(this).parents('.product-grid-item').find('input[name="id"]').val();
var product_price = $(this).parents('.product-grid-item').find('a.product-grid-item__price.price span').text();
var product_cprice = $(this).parents('.product-grid-item').find('a.product-grid-item__price.price s').text();
$('.one_time_custom_checkout').attr('variant_id',product_id);
$('.price_single_one_time').text(product_price);
 if($(this).parents('.product-grid-item').find('a.product-grid-item__price.price s').hasClass("null")) {
} else {
$('.price_compare_one_time').text(product_cprice);
}
 if( $('.bundle-flex-product .bundle-custom-btn button.custom_add_to_cart[style="display: none;"]').length )  {
$('.one_time_custom_checkout').removeAttr('disabled');
$('.price_flex_inner_one_time').addClass('active');
} else {
$('.one_time_custom_checkout').attr('disabled','disabled');
$('.price_flex_inner_one_time').removeClass('active');
 }
});



$('.selected_design_item_custom').each(function(){
var this_element_new = $(this);
var product_id = $(this).find('.remove_design').attr('data_id');
var check_element = $('.custom-counter.bundle-count[unique_id="'+product_id+'"]');
 if( check_element.length ){
} else {
  this_element_new.remove();
}
});
}, 500);
});



$(document).on("click", ".featured-collection.show_price_single .custom_hk_button.add_to_cart_popup.popup_bottom_buttons", function (e) {
$('.one_time_custom_checkout').trigger('click');
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
setTimeout(function() {
this_element.removeClass('loading_hk');
$('.featured-collection:has(.bundle-flex-product)').hide();
}, 3500);
});



$(document).on("click", '.featured-collection .bundle-flex-product .product-grid-item', function (e) {
var product_id = $(this).find('button.custom_add_to_cart').attr('product_id');
 if( $(this).find('.bundle-custom-btn button.custom_add_to_cart[style="display: none;"]').length ){
var image_link = $(this).find('.product-grid-item__image img').attr('src');
var image_link = image_link.split("?")[0];
var product_title =$(this).find('.product-grid-item__title').text();
var product_id = $(this).find('button.custom_add_to_cart').attr('product_id');
var html = '<div class="selected_design_item_custom" title="'+product_title+'"><span class="product_titlte_selected">'+product_title+'</span><img src="'+image_link+'" width="auto" height="auto" loading="eager" fetchpriority="high" alt="selected_image"><span class="remove_design" data_id="'+product_id+'"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.92505 2.875L2.67505 7.125" stroke="#33363F" stroke-width="1.275" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.67505 2.875L6.92505 7.125" stroke="#33363F" stroke-width="1.275" stroke-linecap="round" stroke-linejoin="round"/></svg></span></div>'
if( $('.selected_design_item_custom[title="'+product_title+'"]').length ) {
} else {
   $('.selected_designs_custom').append(html);
}
} else {
$('.remove_design[data_id="'+product_id+'"]').trigger('click');
 }
});



$(document).on("click", '.featured-collection.show_price_single .bundle-flex-product .product-grid-item ', function (e) {
$('button.custom_add_to_cart').removeAttr('disabled');
});



$(document).on("click", ".remove_design", function (e) {
var product_id = $(this).attr('data_id');
var quantity = parseInt($('.custom-counter.bundle-count[unique_id="'+product_id+'"] input.custom-count').val());
if (quantity == 1) {
$(this).parents('.selected_design_item_custom').remove();
}
$('.custom-counter.bundle-count[unique_id="'+product_id+'"] .minus-product').trigger('click');


setTimeout(function() {
var designs_total = parseInt($('.plans_main_item.active').attr('data_tab'));
designs_total = designs_total+1;
  var selected_designs =0;
$('.meal-wrapper .product').each(function(){
var selected_quantity = parseInt($(this).find('input.custom-count').val());
selected_designs = selected_designs + selected_quantity;
});
var left_designs = designs_total-selected_designs;
if(left_designs>0){
$('.popup_bottom_buttons_main_left').show();
$('.popup_bottom_buttons_main_add').hide();
$('span.left_designs').text(left_designs).attr('value',left_designs);
} else {
$('.popup_bottom_buttons_main_left').hide();
$('.popup_bottom_buttons_main_add').show();
}
}, 500);


});



$(document).on("change", ".bundle-feature .product__selectors .radio__fieldset input", function (e) {
var selling_plan = $('.bundle-feature .product__selectors .radio__fieldset input:checked+label').attr('selling_plan');
$('input.selling_plan-cust').val(selling_plan);
});
